/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  SearchFeedsRequest,
  SearchFeedsResponse,
  SearchMessageResponse,
  SearchMessagesRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class WorkspaceId<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name FeedsCreate
   * @request POST:/{workspaceId}/search/feeds
   */
  feedsCreate = (workspaceId: string, data: SearchFeedsRequest, params: RequestParams = {}) =>
    this.request<SearchFeedsResponse, any>({
      path: `/${workspaceId}/search/feeds`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name MessagesCreate
   * @request POST:/{workspaceId}/search/messages
   */
  messagesCreate = (workspaceId: string, data: SearchMessagesRequest, params: RequestParams = {}) =>
    this.request<SearchMessageResponse, any>({
      path: `/${workspaceId}/search/messages`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
